import React, { useEffect, useState, useRef } from "react";
import ApiService from "../../../Services/user/service";
import { Heart, TrendingUp, HeartIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Wallet,ArrowDownToLine   } from "lucide-react";

const Dashboard = () => {
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [depositModal, setDepositModal] = useState(false);
  const [depositAmount, setDepositAmount] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [receiptBase64, setReceiptBase64] = useState("");
  const [typeToFetch, setTypeToFetch] = useState("volume");
  const [marketAnalysis, setMarketAnalysis] = useState([]);
  const currency = localStorage.getItem("currentCurrency");
  const username = localStorage.getItem("UserName") || "User";
  const userid = localStorage.getItem("user_id") || "User";
  const [paymentMethod, setPaymentMethod] = useState("");
  const depositQuickAmounts =
    currency === "1"
      ? [10000, 25000, 50000]   // INR
      : [100, 500, 1000];     // USD
  const navigate = useNavigate();
  const [funds, setFunds] = useState([]);
  const markets = [
    { title: "NIFTY 50", value: "26142.70", change: "+0.42%" },
    { title: "BANK NIFTY", value: "59767.00", change: "+0.18%" },
    { title: "FIN NIFTY", value: "27820.00", change: "-0.08%" },
    { title: "SENSEX", value: "86287.00", change: "+0.11%" },
    { title: "BANKEX", value: "-", change: "" },
    { title: "SBIN", value: "962.40", change: "+0.05%" },
  ];

  const banners = [
    {
      title: "📊 Advanced Analytics",
      desc: "Track your trades in real time",
      btn: "Try Now",
      class: "banner-1",
      class: "blue",
    },
    {
      title: "🔔 Custom Alerts",
      desc: "Never miss important market moves",
      btn: "Enable Alerts",
      class: "banner-2",
      class: "green",
    },
    {
      title: "⚡ Smart Trading",
      desc: "Trade faster with smart insights",
      btn: "Explore",
      class: "banner-3",
      class: "orange",
    },
  ];
  const tabs = ["volume", "price", "gainers", "favorites", "losers"];

  const tabsUsd = ["Top", "Favorites", "Popular"];
  const [Faoriteusddata, setFavoriteusddata] = useState([]);
  const [userdetails, setUserdetails] = useState([]);

  const USD_TO_INR = 87;
  const convertedInr =
    currency !== "1" && depositAmount
      ? (Number(depositAmount) * USD_TO_INR).toFixed(2)
      : "";
  const getChangeClass = (change) => {
    if (!change) return "text-muted";
    return change.trim().startsWith("-") ? "text-danger" : "text-success";
  };

  const getUserDetail = async (user_id) => {
    const res = await ApiService.getUserDetail(user_id);
    setFunds(res?.data?.data || []);
    console.log(res.data);
  };

  useEffect(() => {
    getUserDetail(userid);
  }, []);


  const getFavoritesData = async () => {
    try {
      const res = await ApiService.getFavorites(userid);
      setFavoriteusddata(res.data.data);
      console.log("data is ", res.data.data);
    } catch (err) {
      console.log(err)
    }
  }


  useEffect(() => {
    getFavoritesData();
  }, []);

  const fetchuserdetails = async () => {
    try {

      const res = await ApiService.getUserDetail(userid);
      console.log("payemnt History", res.data.data);
      setUserdetails(res.data.data[0]);
    } catch (err) {
      console.log(err)
    }
  }
  const handleDepositSubmit = async () => {
    if (!depositAmount || Number(depositAmount) <= 0) {
      toast.error("Enter valid deposit amount");
      return;
    }

    if (!transactionId) {
      toast.error("Enter transaction ID");
      return;
    }

    if (!receiptBase64) {
      toast.error("Upload payment receipt");
      return;
    }

    const payload = {
      userid: userid,
      Balance: Number(depositAmount),
      type: 1, // 1 = deposit
      transactionId: transactionId,
      ScreenShot: receiptBase64
    };

    console.log("Deposit Payload:", payload);

    try {
      if (currency === "1") {
        await ApiService.withdrawalDepositInr(payload);
      } else {
        await ApiService.withdrawalDeposit(payload);
      }
      toast.success("Deposit request submitted");
    } catch (err) {
      console.error(err);
      toast.error("Deposit failed");
    } finally {
      setDepositModal(false);
      setDepositAmount("");
      setTransactionId("");
      setReceiptBase64("");

      await fetchuserdetails();
    }

  };

  const resetDepositForm = () => {
    setDepositAmount("");
    setTransactionId("");
    setReceiptBase64("");
  };

  const closeDepositModal = () => {
    setDepositModal(false);
    resetDepositForm();
  };


  const handleReceiptUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setReceiptBase64(reader.result); // base64
    };
    reader.readAsDataURL(file);
  };


  const fetchmarketlist = async () => {
    const payload = {
      type: typeToFetch,
    }
    try {
      const res = await ApiService.getMarketList(payload);
      setMarketAnalysis(res.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchmarketlist();
  }, [typeToFetch,]);





  useEffect(() => {
    if (!sliderRef.current) return;

    const slider = sliderRef.current;
    let index = 0;

    const interval = setInterval(() => {
      index = (index + 1) % banners.length;

      slider.style.transform = `translateX(-${index * 100}%)`;

      setActiveIndex(index); // 🔥 dot yahin change ho raha
    }, 2000);

    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    if (currency === "1") {
      setTypeToFetch("volume"); // INR default
    } else if (currency === "0") {
      setTypeToFetch("Top"); // USD default
    }
  }, [currency]);



  const handleRemoveFavorite = async (item) => {

    try {
      const payload = {
        userid: userid,
        symbolname: item.symbol
      }
      const res = await ApiService.removeFavoriteUsd(payload);
      toast.success(res?.data?.message || "Favorite removed successfully");
      getFavoritesData();
    } catch (err) {
      console.log(err);
    }
  }




  return (
    <div className="container-fluid">
      {/* Main Card / Shell */}
      <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
        <div className="card-header">
          {/* Header */}
          <div className="d-flex align-items-center gap-3">
            <div
              className="rounded-circle bg-gradient p-2 d-flex align-items-center justify-content-center shadow-sm"
              style={{ width: 64, height: 64 }}
            >
              <img
                src="/assets/images/avatar/1.png"
                alt="avatar"
                className="rounded-circle"
                style={{ width: 48, height: 48, objectFit: "cover" }}
              />
            </div>
            <div>
              <div className="h6 mb-1 d-flex align-items-center">
                {username}
                <span className="badge bg-success ms-2 rounded-pill">
                  Premium
                </span>
              </div>
              {/* <small className="text-muted">User ID: {userid}</small> */}
            </div>
          </div>

          <div className="d-flex align-items-center gap-3 ms-md-auto">
            <div className="bg-body-tertiary text-dark rounded-3 px-3 py-2 d-flex align-items-center gap-3 shadow-sm">
              <div>
                <div className="text-muted small mb-1"> <Wallet size={20} /> Available Funds</div>
                {funds.map((item) => (
                  <div key={item._id} className="fw-bold">
                    {currency === "1" ? item.Inr_Balance.toFixed(3) : item.Balance.toFixed(3)}
                  </div>
                ))}

              </div>
              <button
                onClick={() => setDepositModal(true)} className="btn btn-success  rounded-pill px-3">
            <ArrowDownToLine size={16} /> Deposit
              </button>
            </div>
          </div>
        </div>

        <div className="card-body p-4">
          {/* Top sections grid */}
          <div className="row g-4">
            {/* Markets Today */}
            <div className="col-lg-7">
              <div className="card bg-body-tertiary border-0 rounded-4 h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h5 className="card-title mb-0"><TrendingUp className="text-success" size={28} /> Markets {currency === "1" ? "Today" : ""}</h5>
                      <small className="text-muted">
                        Live indices & stocks overview
                      </small>
                    </div>
                    <span className="badge bg-success-subtle text-success border border-success-subtle">
                      Realtime
                    </span>
                  </div>



                  {currency === "0" && (
                    <div className="banner-wrapper">
                      <div className="market-listsss" ref={sliderRef}>
                        {banners.map((item, i) => (
                          <div className={`trade-banner ${item.class}`} key={i}>
                            <h5>{item.title}</h5>
                            <p>{item.desc}</p>
                            <p className="button-style-banner">{item.btn}</p>
                          </div>
                        ))}
                      </div>

                      <div className="dots">
                        {banners.map((_, i) => (
                          <span
                            key={i}
                            className={`dot ${i === activeIndex ? "active" : ""}`}
                          />
                        ))}
                      </div>
                    </div>


                  )}







                  {
                    currency === "0" && (
                      <div className="market-listss mt-3">

                        <div className="market-item" onClick={() => console.log("BTC")}>
                          <span className="market-name crypto-name">
                            <img src="/assets/images/dashboard/bitcoin.png" alt="BTC"  />
                            BITCOIN</span>
                          <span className="market-price">$ 42,350</span>
                        </div>

                        <div className="market-item" onClick={() => console.log("BTC")}>
                          <span className="market-name crypto-name">
                            <img src="/assets/images/dashboard/usdtusd.png" alt="BTC"  />
                            USDTUSD</span>
                          <span className="market-price">$ 42,350</span>
                        </div>

                        <div className="market-item" onClick={() => console.log("ETH")}>
                          <span className="market-name crypto-name">
                            <img src="/assets/images/dashboard/ethereum.png" alt="BTC"  />
                            ETHEREUM</span>
                          <span className="market-price">$ 2,280</span>
                        </div>

                        <div className="market-item" onClick={() => console.log("DOGE")}>
                          <span className="market-name crypto-name">
                            <img src="/assets/images/dashboard/dogeusd.png" alt="BTC"  />
                            DOGEUSD</span>
                          <span className="market-price">$ 0.082</span>
                        </div>

                      </div>
                    )
                  }



                  {
                    currency === "1" && (
                      <div className="row g-3">
                        {markets.map((m, idx) => (
                          <div key={idx} className="col-6 col-md-4">
                            <div className="p-3 rounded-3 border bg-white h-100">
                              <small className="text-muted d-block mb-1">
                                {m.title}
                              </small>
                              <div className="fw-bold mb-1">₹{m.value}</div>
                              <small className={getChangeClass(m.change)}>
                                {m.change || "--"}
                              </small>
                            </div>
                          </div>
                        ))}
                      </div>
                    )
                  }

                  <div className="row mt-4 g-3">
                    <div className="col-12 col-md-4">
                      <button
                        onClick={() => navigate("/user/option-chain")}
                        className="w-100 btn btn-success rounded-4 py-3 d-flex flex-column align-items-center justify-content-center">
                        <i className="fa-solid fa-arrow-up-long mb-2"></i>
                        <div className="fw-semibold">Option Chain</div>
                        <small className="text-light-50">
                          View strikes & OI
                        </small>
                      </button>
                    </div>

                    <div className="col-12 col-md-4">
                      <button
                        onClick={() => navigate("/user/news")}
                        className="w-100 btn btn-outline-secondary rounded-4 py-3 d-flex flex-column align-items-center justify-content-center">
                        <i className="fa-solid fa-newspaper mb-2"></i>
                        <div className="fw-semibold">News</div>
                        <small className="text-muted">Trade from news</small>
                      </button>
                    </div>

                    <div className="col-12 col-md-4" onClick={() => navigate("/user/research")}>
                      <button className="w-100 btn btn-warning rounded-4 py-3 d-flex flex-column align-items-center justify-content-center text-dark">
                        <i className="fa-solid fa-bolt mb-2"></i>
                        <div className="fw-semibold">Research</div>
                        <small className="">Screeners & ideas</small>
                      </button>
                    </div>
                  </div>

                  {currency === "1" && (
                    <div className="mt-4 p-3 border rounded-3 bg-white d-flex justify-content-between align-items-center">
                      <div>
                        <div className="fw-semibold">My Favorites</div>
                        <small className="text-muted">
                          Quickly access your watchlist
                        </small>
                      </div>
                      <button
                        onClick={() => navigate("/user/favorites")}
                        className="btn btn-sm btn-link text-muted">
                        <i className="fa-solid fa-chevron-right"></i>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Market Analysis */}
            <div className="col-lg-5">
              <div className="card bg-body-tertiary border-0 rounded-4 h-100">
                {currency === "1" && (
                  <div className="card-body">
                    <h5 className="card-title mb-2">Market Analysis</h5>
                    <div className="d-flex justify-content-between mb-3 align-items-center">


                      <div className="tabs-wrapper">
                        <div
                          className="tab-indicator"
                          style={{
                            transform: `translateX(${tabs.indexOf(typeToFetch) * 100}%)`,
                          }}
                        />

                        {tabs.map((tab) => (
                          <button
                            key={tab}
                            className={`tab-btn ${typeToFetch === tab ? "active" : ""}`}
                            onClick={() => setTypeToFetch(tab)}
                          >
                            {tab.toUpperCase()}
                          </button>
                        ))}
                      </div>

                    </div>

                    <div className="small text-muted mb-3">
                      Top contracts by traded volume
                    </div>

                    <div className="row g-3" style={{
                      maxHeight: "350px",
                      overflowY: "auto"
                    }} >
                      {marketAnalysis.map((analysis, index) => (
                        <div key={index} className="col-12">
                          <div className="p-3 border rounded-3 bg-white d-flex justify-content-between align-items-center">
                            <div>
                              <div className="fw-semibold">{analysis.name}</div>
                              <small className="text-muted">
                                instrument_token
                              </small>
                            </div>
                            <div className="text-end">

                            </div>
                          </div>
                        </div>
                      ))}
                    </div>


                  </div>
                )}


                {currency === "0" && (
                  <div className="card-body">
                    <h4>Cryptex Rating</h4>
                    <div className="d-flex justify-content-between mb-3 align-items-center">


                      <div className="tabs-wrapper">
                        <div
                          className="tab-indicator"
                          style={{
                            transform: `translateX(${tabs.indexOf(typeToFetch) * 100}%)`,
                          }}
                        />

                        {tabsUsd.map((tab) => (
                          <button
                            key={tab}
                            className={`tab-btn ${typeToFetch === tab ? "active" : ""}`}
                            onClick={() => setTypeToFetch(tab)}
                          >
                            {tab.toUpperCase()}
                          </button>
                        ))}
                      </div>
                    </div>

                    {typeToFetch === "Popular" && currency === "0" && (

                       <div className="market-listss mt-3">

                        <div className="market-item" onClick={() => console.log("BTC")}>
                          <span className="market-name crypto-name">
                            <img src="/assets/images/dashboard/bitcoin.png" alt="BTC"  />
                            BITCOIN</span>
                          <span className="market-price">$ 42,350</span>
                        </div>

                        <div className="market-item" onClick={() => console.log("BTC")}>
                          <span className="market-name crypto-name">
                            <img src="/assets/images/dashboard/usdtusd.png" alt="BTC"  />
                            USDTUSD</span>
                          <span className="market-price">$ 42,350</span>
                        </div>

                        <div className="market-item" onClick={() => console.log("ETH")}>
                          <span className="market-name crypto-name">
                            <img src="/assets/images/dashboard/ethereum.png" alt="BTC"  />
                            ETHEREUM</span>
                          <span className="market-price">$ 2,280</span>
                        </div>

                        <div className="market-item" onClick={() => console.log("DOGE")}>
                          <span className="market-name crypto-name">
                            <img src="/assets/images/dashboard/dogeusd.png" alt="BTC"  />
                            DOGEUSD</span>
                          <span className="market-price">$ 0.082</span>
                        </div>

                      </div>

                    )}

                    {typeToFetch === "Top" && currency === "0" && (

                        <div className="market-listss mt-3">

                        <div className="market-item" onClick={() => console.log("BTC")}>
                          <span className="market-name crypto-name">
                            <img src="/assets/images/dashboard/bitcoin.png" alt="BTC"  />
                            BITCOIN</span>
                          <span className="market-price">$ 42,350</span>
                        </div>

                        <div className="market-item" onClick={() => console.log("BTC")}>
                          <span className="market-name crypto-name">
                            <img src="/assets/images/dashboard/usdtusd.png" alt="BTC"  />
                            USDTUSD</span>
                          <span className="market-price">$ 42,350</span>
                        </div>

                        <div className="market-item" onClick={() => console.log("ETH")}>
                          <span className="market-name crypto-name">
                            <img src="/assets/images/dashboard/ethereum.png" alt="BTC"  />
                            ETHEREUM</span>
                          <span className="market-price">$ 2,280</span>
                        </div>

                        <div className="market-item" onClick={() => console.log("DOGE")}>
                          <span className="market-name crypto-name">
                            <img src="/assets/images/dashboard/dogeusd.png" alt="BTC"  />
                            DOGEUSD</span>
                          <span className="market-price">$ 0.082</span>
                        </div>

                      </div>

                    )}


                    {typeToFetch === "Favorites" && currency === "0" && (
                      <div>
                        <div className="list-header d-flex justify-content-between align-items-center">
                          <span className="list-title">Name</span>
                          <span className="list-title">Current Price</span>
                        </div>


                        {Faoriteusddata.length === 0 ? (
                          <p className="text-center text-muted">No favorites added</p>
                        ) : (
                          Faoriteusddata.map((item, index) => (
                            <div
                              key={index}
                              className="d-flex justify-content-between align-items-center mb-3"
                            >
                              {/* Left */}
                              <div>
                                <h6 className="mb-0">{item.symbol}</h6>
                                <small className="text-muted">{item.exch_seg}</small>
                              </div>

                              {/* Right */}
                              <div className="d-flex align-items-center gap-2">
                                <h6 className="mb-0">$100</h6>

                                <button
                                  className="fav-heart-btn"
                                  onClick={() => handleRemoveFavorite(item)}
                                  aria-label="Remove from favorites"
                                >
                                  <HeartIcon size={14} className="fav-heart-icon" />
                                </button>

                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>

                )}
              </div>
            </div>
          </div>
        </div>
      </div>



      {depositModal && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              {/* HEADER */}
              <div className="modal-header">
                <h5 className="modal-title">Add Funds</h5>
                <button className="btn-close" onClick={() => closeDepositModal()} />
              </div>

              {/* BODY */}
              <div className="modal-body">

                <div className="D-flex justify-content-between">
                  <div>
                    {/* AMOUNT INPUT */}
                    <input
                      type="number"
                      className="form-control mb-3"
                      placeholder="Enter deposit amount"
                      value={depositAmount}
                      onChange={(e) => setDepositAmount(e.target.value)}
                    />
                  </div>

                  <div>
                    {/* USD → INR PREVIEW */}
                    {currency !== "1" && depositAmount && (
                      <div className="text-end mb-2">
                        <small className="text-muted">
                          ≈ ₹{convertedInr} INR
                        </small>
                      </div>
                    )}

                  </div>
                </div>



                {/* QUICK AMOUNT BUTTONS (⬇️ QR KE NICHE) */}
                <div className="d-flex justify-content-center gap-2 mb-3">
                  {depositQuickAmounts.map((amt) => (
                    <button
                      key={amt}
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() =>
                        setDepositAmount(prev =>
                          (Number(prev || 0) + amt).toString()
                        )
                      }
                    >
                      +{currency === "1" ? "₹" : "$"}{amt}
                    </button>
                  ))}
                </div>





                {currency === "1" && (
                  <div>
                    <div className="text-center mb-3">
                      <img
                        src="/qr-code.png"   // backend/static QR
                        alt="QR Code"
                        style={{ width: 180 }}
                      />
                      <small className="text-muted d-block mt-1">
                        Scan & Pay
                      </small>
                    </div>


                    <div className="mb-3">
                      <label className="form-label">Upload Payment Receipt</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleReceiptUpload}
                      />
                    </div>


                    <input
                      type="text"
                      className="form-control mb-3"
                      placeholder="Enter Transaction ID"
                      value={transactionId}
                      onChange={(e) => setTransactionId(e.target.value)}
                    />


                    <button
                      className="btn btn-success w-100"
                      onClick={handleDepositSubmit}
                    >
                      Submit Deposit
                    </button>
                  </div>
                )}



                {currency === "0" && (
                  <div>
                    <h6 className="mb-3">Select Payment Method</h6>

                    {/* Payment method cards */}
                    <div className="row g-3 mb-3">
                      {/* Crypto Transfer */}
                      <div className="col-6">
                        <div
                          className={`payment-card ${paymentMethod === "crypto" ? "active" : ""
                            }`}
                          onClick={() => setPaymentMethod("crypto")}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h6 className="mb-1">Crypto Transfer</h6>
                              <small className="text-muted">Online payment</small>
                            </div>

                            {paymentMethod === "crypto" && (
                              <span className="check-badge">✓</span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* INR to USDT */}
                      <div className="col-6">
                        <div
                          className={`payment-card ${paymentMethod === "inr_usdt" ? "active" : ""
                            }`}
                          onClick={() => setPaymentMethod("inr_usdt")}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h6 className="mb-1">INR → USDT</h6>
                              <small className="text-muted">Manual payment</small>
                            </div>

                            {paymentMethod === "inr_usdt" && (
                              <span className="check-badge">✓</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Selected method info */}
                    {paymentMethod && (
                      <div className="alert alert-success py-2 mb-3">
                        <strong>Selected Method:</strong>{" "}
                        {paymentMethod === "crypto"
                          ? "Crypto Transfer"
                          : "INR → USDT Manual Payment"}
                      </div>
                    )}

                    {/* Crypto payment form */}
                    {paymentMethod === "crypto" && (
                      <div>
                        <h6 className="mb-2 text-success">Crypto Transfer Payment</h6>

                        <div className="text-center mb-3">
                          <img src="/qr-code.png" alt="QR" style={{ width: 180 }} />
                          <small className="text-muted d-block mt-1">Scan & Pay</small>
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Upload Payment Receipt</label>
                          <input
                            type="file"
                            className="form-control"
                            accept="image/*"
                            onChange={handleReceiptUpload}
                          />
                        </div>

                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="Enter Transaction ID"
                          value={transactionId}
                          onChange={(e) => setTransactionId(e.target.value)}
                        />

                        <button
                          className="btn btn-success w-100"
                          onClick={handleDepositSubmit}
                        >
                          Submit Deposit
                        </button>
                      </div>
                    )}

                    {/* INR → USDT payment form */}
                    {paymentMethod === "inr_usdt" && (
                      <div>
                        <h6 className="mb-2 text-success">INR → USDT Manual Payment</h6>

                        <div className="text-center mb-3">
                          <img src="/qr-code.png" alt="QR" style={{ width: 180 }} />
                          <small className="text-muted d-block mt-1">Scan & Pay</small>
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Upload Payment Receipt</label>
                          <input
                            type="file"
                            className="form-control"
                            accept="image/*"
                            onChange={handleReceiptUpload}
                          />
                        </div>

                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="Enter UTR / Transaction ID"
                          value={transactionId}
                          onChange={(e) => setTransactionId(e.target.value)}
                        />

                        <button
                          className="btn btn-success w-100"
                          onClick={handleDepositSubmit}
                        >
                          Submit Deposit
                        </button>
                      </div>
                    )}
                  </div>
                )}







              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
